(() => {
  'use strict';
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const scrollBehavior = reducedMotion ? 'auto' : 'smooth';
  let lastDialogTrigger = null;

  function openDialog(id, trigger) {
    const dialog = document.getElementById(id);
    if (!dialog) return;
    lastDialogTrigger = trigger || document.activeElement;
    if (!dialog.open) dialog.showModal();
  }
  function closeDialog(dialog) {
    if (!dialog) return;
    dialog.close();
    lastDialogTrigger?.focus();
  }
  $$('[data-open-dialog]').forEach(button => button.addEventListener('click', () => openDialog(button.dataset.openDialog, button)));
  $$('[data-close-dialog]').forEach(button => button.addEventListener('click', () => closeDialog(button.closest('dialog'))));
  $$('dialog').forEach(dialog => {
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) closeDialog(dialog);
    });
    dialog.addEventListener('cancel', () => lastDialogTrigger?.focus());
    $$('a[href*="#"]', dialog).forEach(link => link.addEventListener('click', () => closeDialog(dialog)));
  });

  $$('[data-tabs]').forEach(tabs => {
    const buttons = $$('[data-tab]', tabs);
    const panels = $$('[data-panel]', tabs);
    const activate = button => {
      buttons.forEach(item => {
        const active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-selected', String(active));
        item.tabIndex = active ? 0 : -1;
      });
      panels.forEach(panel => { panel.hidden = panel.id !== button.dataset.tab; });
    };
    buttons.forEach((button, i) => {
      button.addEventListener('click', () => activate(button));
      button.addEventListener('keydown', event => {
        let target;
        if (event.key === 'ArrowRight') target = buttons[(i + 1) % buttons.length];
        if (event.key === 'ArrowLeft') target = buttons[(i - 1 + buttons.length) % buttons.length];
        if (event.key === 'Home') target = buttons[0];
        if (event.key === 'End') target = buttons.at(-1);
        if (target) { event.preventDefault(); activate(target); target.focus(); }
      });
    });
  });

  $$('[data-gallery]').forEach(gallery => {
    const track = $('[data-gallery-track]', gallery);
    const slides = $$('[data-gallery-slide]', gallery);
    const thumbnails = $$('[data-gallery-index]', gallery);
    const counter = $('[data-gallery-current]', gallery);
    let current = 0;
    const go = index => {
      index = Math.max(0, Math.min(index, slides.length - 1));
      track.scrollTo({ left: slides[index].offsetLeft - slides[0].offsetLeft, behavior: scrollBehavior });
    };
    thumbnails.forEach(button => button.addEventListener('click', () => go(Number(button.dataset.galleryIndex))));
    let ticking = false;
    track.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        current = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
        thumbnails.forEach((button, i) => { button.classList.toggle('is-active', i === current); button.setAttribute('aria-current', String(i === current)); });
        if (counter) counter.textContent = String(current + 1);
        const thumb = thumbnails[current];
        const container = thumb?.parentElement;
        if (thumb && container && (thumb.offsetLeft < container.scrollLeft || thumb.offsetLeft + thumb.offsetWidth > container.scrollLeft + container.clientWidth)) container.scrollTo({ left: thumb.offsetLeft - container.offsetLeft, behavior: scrollBehavior });
        ticking = false;
      });
    }, { passive: true });
    track.addEventListener('keydown', event => {
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); go(current + (event.key === 'ArrowRight' ? 1 : -1)); }
    });
    $('[data-gallery-zoom]', gallery)?.addEventListener('click', event => {
      const source = $('img', slides[current]);
      const zoom = $('[data-zoom-image]');
      zoom.src = source.currentSrc || source.src;
      zoom.alt = source.alt;
      openDialog('zoom-dialog', event.currentTarget);
    });
  });

  $$('[data-carousel]').forEach(carousel => {
    const track = $('[data-carousel-track]', carousel);
    const slides = $$('.carousel-slide', track);
    const dots = $$('[data-carousel-index]', carousel);
    const prev = $('[data-carousel-prev]', carousel);
    const next = $('[data-carousel-next]', carousel);
    let current = 0;
    const go = index => { const i = Math.max(0, Math.min(index, slides.length - 1)); track.scrollTo({ left: slides[i].offsetLeft - slides[0].offsetLeft, behavior: scrollBehavior }); };
    const update = () => {
      const width = slides[1] ? slides[1].offsetLeft - slides[0].offsetLeft : track.clientWidth;
      current = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / width)));
      dots.forEach((dot, i) => { dot.classList.toggle('is-active', i === current); dot.setAttribute('aria-current', String(i === current)); });
      if (prev) prev.disabled = current === 0;
      if (next) next.disabled = current === slides.length - 1;
    };
    prev?.addEventListener('click', () => go(current - 1));
    next?.addEventListener('click', () => go(current + 1));
    dots.forEach(dot => dot.addEventListener('click', () => go(Number(dot.dataset.carouselIndex))));
    track.addEventListener('scroll', update, { passive: true });
    track.addEventListener('keydown', event => {
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); go(current + (event.key === 'ArrowRight' ? 1 : -1)); }
    });
    update();
  });

  $$('[data-quantity-change]').forEach(button => button.addEventListener('click', () => {
    const input = $('input', button.closest('.quantity-selector'));
    const min = Number(input.min) || 0;
    const max = input.max ? Number(input.max) : 999;
    input.value = String(Math.max(min, Math.min(max, (Number(input.value) || min) + Number(button.dataset.quantityChange))));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }));

  const stickyPurchase = $('[data-sticky-purchase]');
  const purchaseBlock = $('[data-purchase-block]');
  if (stickyPurchase && purchaseBlock && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => {
      const entry = entries[0];
      stickyPurchase.hidden = entry.isIntersecting || entry.boundingClientRect.top > window.innerHeight;
    }, { threshold: 0 });
    observer.observe(purchaseBlock);
  }
  const productNav = $('[data-product-nav]');
  if (productNav) {
    const links = $$('a', productNav);
    const sections = links.map(link => $(link.getAttribute('href'))).filter(Boolean);
    let ticking = false;
    addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const offset = productNav.getBoundingClientRect().bottom + 80;
        let active = sections[0];
        sections.forEach(section => { if (section.getBoundingClientRect().top <= offset) active = section; });
        links.forEach(link => link.classList.toggle('is-active', link.hash === `#${active?.id}`));
        ticking = false;
      });
    }, { passive: true });
  }

  const salesEnabled = document.body.dataset.salesEnabled === 'true';
  const cartUrl = document.body.dataset.cartUrl || '/cart';
  const addUrl = document.body.dataset.cartAddUrl || '/cart/add';
  const money = (cents, currency) => new Intl.NumberFormat('es-AR', { style: 'currency', currency: currency || document.body.dataset.moneyCurrency || 'ARS' }).format(cents / 100);
  const make = (tag, className, text) => { const element = document.createElement(tag); if (className) element.className = className; if (text != null) element.textContent = text; return element; };
  function renderCart(cart) {
    $$('[data-cart-count]').forEach(element => { element.textContent = String(cart.item_count); });
    const body = $('[data-cart-body]');
    const footer = $('[data-cart-footer]');
    body.replaceChildren();
    if (!cart.items.length) {
      const empty = make('div', 'empty-cart');
      empty.append(make('p', '', 'Tu carrito está vacío'));
      const link = make('a', 'button', 'Conocé Aspiradora TREVO'); link.href = '/#producto'; link.addEventListener('click', () => closeDialog($('#cart-dialog'))); empty.append(link); body.append(empty);
      footer.hidden = true;
      return;
    }
    cart.items.forEach(item => {
      const row = make('div', 'cart-drawer-item');
      const img = make('img'); img.src = item.featured_image?.url || item.image || ''; img.alt = item.product_title || 'Aspiradora TREVO'; img.width = 85; img.height = 85;
      const info = make('div'); info.append(make('h3', '', item.product_title || 'Aspiradora TREVO')); info.append(make('p', '', `Cantidad: ${item.quantity}`)); info.append(make('p', '', money(item.final_line_price, cart.currency))); row.append(img, info); body.append(row);
    });
    $('[data-cart-total]').textContent = money(cart.total_price, cart.currency);
    footer.hidden = !salesEnabled;
  }
  async function loadCart() {
    const response = await fetch(`${cartUrl}.js`, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('No se pudo cargar el carrito.');
    const cart = await response.json(); renderCart(cart); return cart;
  }
  $$('[data-open-cart]').forEach(link => link.addEventListener('click', async event => {
    event.preventDefault(); openDialog('cart-dialog', link);
    if (!salesEnabled) return;
    try { await loadCart(); } catch { location.assign(cartUrl); }
  }));
  const cartErrorMessage = result => {
    const raw = String(result.description || result.message || '').toLowerCase();
    if (/sold out|out of stock|not enough|inventory|can't add more|cannot add more|agotad|sin stock|existencias|inventario/.test(raw)) return 'No hay suficiente stock para la cantidad seleccionada. Probá con una cantidad menor o consultanos.';
    if (/not available|unavailable|not found|no est[aá] disponible|no disponible/.test(raw)) return 'Este producto no está disponible para agregar al carrito. Consultanos por WhatsApp.';
    return 'No se pudo agregar el producto. Intentá nuevamente o consultanos por WhatsApp.';
  };
  const productForm = $('#trevo-product-form');
  productForm?.addEventListener('submit', async event => {
    if (!salesEnabled) return;
    event.preventDefault();
    const submitters = $$('[type="submit"]', productForm).concat($$('button[form="trevo-product-form"]'));
    const error = $('[data-product-error]', productForm);
    submitters.forEach(button => { button.disabled = true; button.setAttribute('aria-busy', 'true'); });
    if (error) error.hidden = true;
    try {
      const response = await fetch(`${addUrl}.js`, { method: 'POST', body: new FormData(productForm), credentials: 'same-origin', headers: { Accept: 'application/json' } });
      const result = await response.json();
      if (!response.ok) throw Object.assign(new Error('cart_add_failed'), { userMessage: cartErrorMessage(result) });
      try { await loadCart(); openDialog('cart-dialog', event.submitter); } catch { location.assign(cartUrl); }
    } catch (failure) {
      if (error) { error.textContent = failure.userMessage || 'No se pudo conectar con la tienda. Revisá tu conexión e intentá nuevamente.'; error.hidden = false; error.scrollIntoView({ block: 'nearest', behavior: scrollBehavior }); }
    } finally {
      submitters.forEach(button => { button.disabled = false; button.removeAttribute('aria-busy'); });
    }
  });
})();
